import qs from 'qs';

export const toQueryParamString = (params = {}) =>
    qs.stringify(params, {
        addQueryPrefix: true,
        encodeValuesOnly: true,
        arrayFormat: 'brackets',
        skipNulls: true,
        filter: (prefix, value) => (value === '' ? undefined : value)
    });
